// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CloudCFO Product Design System — Foundations (tokens only).
   Ported from docs/design/.../colors_and_type.css. Poppins is loaded via
   @fontsource/poppins in src/index.js (no @font-face here). */

:root {
  /* Brand / Primary */
  --twilight-sky: #00449d;
  --twilight-hover: #007bdd;
  --twilight-active: #072b5e;
  --day-sky: #82b1e8; /* brand light tint — secondary chart series */
  --pink-haze: #f7598c;

  /* Ink / Text hierarchy */
  --ink: #0a1f44;
  --ink-soft: #3f526e;
  --storm-gray: #333333;
  --ink-mute: #8b97a8;

  /* Surfaces */
  --surface: #ffffff;
  --canvas: #faf8f5; /* warm off-white page background — never pure white */
  --sky-mist: #ebf2fa;
  --sky-mist-border: #d4e4f5;
  --table-header-bg: #f8f9fa;
  --field-disabled: #f0f2f5;
  --hairline: #e8e2d8;
  --focus-ring: #82b1e8;

  /* Semantic — status badges */
  --success-bg: #e1f5ee;
  --success-text: #0f6e56;
  --warning-bg: #faeeda;
  --warning-text: #854f0b;
  --danger-bg: #fcebeb;
  --danger-text: #a32d2d;
  --info-bg: #ebf2fa;
  --info-text: #0c447c;
  --neutral-bg: #f0f2f5;
  --neutral-text: #3f526e;

  /* Semantic — actions & icons */
  --danger: #e85642;
  --danger-hover: #c73f2d;
  --icon-warning: #ffb31a;
  --icon-success: #1b605d;

  /* Status intents (financial statements — tie-out, figures) */
  --status-success: #1b605d; /* Midnight Green — tie-out ok, positive */
  --midnight-green: #1b605d;
  --amount-positive: #1b605d; /* positive financial figures (teal) */
  --amount-negative: #e85642; /* negative financial figures (orange) */

  /* Backdrop */
  --backdrop: rgba(10, 31, 68, 0.35);

  /* Layout — combined height of the global header + sticky project nav bar.
     Workspace tabs subtract this from the viewport (\`calc(100vh - var(--workspace-chrome-h))\`)
     so each tab owns its own scroll region instead of growing the document.
     Single source of truth for the offset Reports/Dashboard/Policies share. */
  --workspace-chrome-h: 107px;

  /* Rail gradient (replaces the prototype's gradient-blue-rail.png — colors sampled
     from that PNG: a subtle deep-navy fade, NOT a bright-blue ramp) */
  --rail-gradient: linear-gradient(180deg, #003063 0%, #011e50 100%);
  /* Rail foreground (inactive icon + label) — white at 62% over the gradient */
  --rail-fg-muted: rgba(255, 255, 255, 0.62);
  /* Count-badge border — matches the rail's upper gradient stop so the badge reads as inset */
  --rail-badge-border: #003063;

  /* Typography */
  --font-sans: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  /* Serif for financial-statement / report headings so statements read like
     printed documents. Lora is loaded via a <link> in src/index.html. */
  --font-doc: 'Lora', Georgia, 'Times New Roman', serif;
  --h1-size: 24px;
  --h1-weight: 700;
  --h1-tracking: -0.015em;
  --h1-lh: 1.2;
  --h2-size: 20px;
  --h2-weight: 700;
  --h2-tracking: -0.01em;
  --h2-lh: 1.25;
  --h3-size: 16px;
  --h3-weight: 600;
  --h3-tracking: -0.005em;
  --h3-lh: 1.3;
  --h4-size: 14px;
  --h4-weight: 500;
  --h4-tracking: 0;
  --h4-lh: 1.35;
  --body-size: 14px;
  --body-weight: 400;
  --body-lh: 1.6;
  --sm-size: 12px;
  --sm-weight: 400;
  --sm-lh: 1.5;
  --label-size: 11px;
  --label-weight: 600;
  --label-tracking: 0.08em;
  --button-size: 14px;
  --button-weight: 500;

  /* Spacing (4pt grid) */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 24px;
  --space-6: 32px;
  --space-7: 48px;
  --space-8: 64px;

  /* Radius */
  --radius-s: 4px;
  --radius-m: 8px;
  --radius-l: 12px;
  --radius-xl: 20px;
  --radius-full: 9999px;

  /* Elevation */
  --e0: none;
  --e1: 0 1px 3px rgba(10, 31, 68, 0.06), 0 1px 2px rgba(10, 31, 68, 0.04);
  --e2: 0 4px 12px rgba(10, 31, 68, 0.09), 0 2px 4px rgba(10, 31, 68, 0.05);
  --e3: 0 8px 28px rgba(10, 31, 68, 0.13), 0 3px 8px rgba(10, 31, 68, 0.07);
  --e4: 0 20px 48px rgba(10, 31, 68, 0.18), 0 6px 16px rgba(10, 31, 68, 0.1);
}

/* Semantic type classes */
.app-h1 {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 24px;
  font-size: var(--h1-size);
  font-weight: 700;
  font-weight: var(--h1-weight);
  letter-spacing: -0.015em;
  letter-spacing: var(--h1-tracking);
  line-height: 1.2;
  line-height: var(--h1-lh);
  color: #0a1f44;
  color: var(--ink);
  margin: 0;
}
.app-h2 {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 20px;
  font-size: var(--h2-size);
  font-weight: 700;
  font-weight: var(--h2-weight);
  letter-spacing: -0.01em;
  letter-spacing: var(--h2-tracking);
  line-height: 1.25;
  line-height: var(--h2-lh);
  color: #3f526e;
  color: var(--ink-soft);
  margin: 0;
}
.app-h3 {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 16px;
  font-size: var(--h3-size);
  font-weight: 600;
  font-weight: var(--h3-weight);
  letter-spacing: -0.005em;
  letter-spacing: var(--h3-tracking);
  line-height: 1.3;
  line-height: var(--h3-lh);
  color: #3f526e;
  color: var(--ink-soft);
  margin: 0;
}
.app-h4 {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 14px;
  font-size: var(--h4-size);
  font-weight: 500;
  font-weight: var(--h4-weight);
  line-height: 1.35;
  line-height: var(--h4-lh);
  color: #3f526e;
  color: var(--ink-soft);
  margin: 0;
}
.app-body {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 14px;
  font-size: var(--body-size);
  font-weight: 400;
  font-weight: var(--body-weight);
  line-height: 1.6;
  line-height: var(--body-lh);
  color: #333333;
  color: var(--storm-gray);
}
.app-sm {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 12px;
  font-size: var(--sm-size);
  font-weight: 400;
  font-weight: var(--sm-weight);
  line-height: 1.5;
  line-height: var(--sm-lh);
  color: #8b97a8;
  color: var(--ink-mute);
}
.app-label {
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, 'Segoe UI', sans-serif;
  font-family: var(--font-sans);
  font-size: 11px;
  font-size: var(--label-size);
  font-weight: 600;
  font-weight: var(--label-weight);
  letter-spacing: 0.08em;
  letter-spacing: var(--label-tracking);
  text-transform: uppercase;
  color: #8b97a8;
  color: var(--ink-mute);
}

/* Reports viewer animations (TxnPanel overlay + slide-in, create-draft spinner) */
@keyframes repFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes repSlideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes uiSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB,EAAE,8CAA8C;EAClE,oBAAoB;;EAEpB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;;EAEnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB,EAAE,sDAAsD;EACzE,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;;EAErB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;;EAEvB,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,6DAA6D;EAC7D,yBAAyB,EAAE,0CAA0C;EACrE,yBAAyB;EACzB,0BAA0B,EAAE,sCAAsC;EAClE,0BAA0B,EAAE,wCAAwC;;EAEpE,aAAa;EACb,kCAAkC;;EAElC;;;8EAG4E;EAC5E,2BAA2B;;EAE3B;sEACoE;EACpE,kEAAkE;EAClE,6EAA6E;EAC7E,0CAA0C;EAC1C,4FAA4F;EAC5F,4BAA4B;;EAE5B,eAAe;EACf,oIAAwE;EACxE;wEACsE;EACtE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;;EAEpB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;;EAErB,cAAc;EACd,UAAU;EACV,wEAAwE;EACxE,yEAAyE;EACzE,yEAAyE;EACzE,0EAA0E;AAC5E;;AAEA,0BAA0B;AAC1B;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAAyB;EAAzB,yBAAyB;EACzB,gBAA6B;EAA7B,6BAA6B;EAC7B,wBAAkC;EAAlC,kCAAkC;EAClC,gBAAyB;EAAzB,yBAAyB;EACzB,cAAiB;EAAjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAAyB;EAAzB,yBAAyB;EACzB,gBAA6B;EAA7B,6BAA6B;EAC7B,uBAAkC;EAAlC,kCAAkC;EAClC,iBAAyB;EAAzB,yBAAyB;EACzB,cAAsB;EAAtB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAAyB;EAAzB,yBAAyB;EACzB,gBAA6B;EAA7B,6BAA6B;EAC7B,wBAAkC;EAAlC,kCAAkC;EAClC,gBAAyB;EAAzB,yBAAyB;EACzB,cAAsB;EAAtB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAAyB;EAAzB,yBAAyB;EACzB,gBAA6B;EAA7B,6BAA6B;EAC7B,iBAAyB;EAAzB,yBAAyB;EACzB,cAAsB;EAAtB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAA2B;EAA3B,2BAA2B;EAC3B,gBAA+B;EAA/B,+BAA+B;EAC/B,gBAA2B;EAA3B,2BAA2B;EAC3B,cAAwB;EAAxB,wBAAwB;AAC1B;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAAyB;EAAzB,yBAAyB;EACzB,gBAA6B;EAA7B,6BAA6B;EAC7B,gBAAyB;EAAzB,yBAAyB;EACzB,cAAsB;EAAtB,sBAAsB;AACxB;AACA;EACE,oIAA6B;EAA7B,6BAA6B;EAC7B,eAA4B;EAA5B,4BAA4B;EAC5B,gBAAgC;EAAhC,gCAAgC;EAChC,sBAAqC;EAArC,qCAAqC;EACrC,yBAAyB;EACzB,cAAsB;EAAtB,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* CloudCFO Product Design System — Foundations (tokens only).\n   Ported from docs/design/.../colors_and_type.css. Poppins is loaded via\n   @fontsource/poppins in src/index.js (no @font-face here). */\n\n:root {\n  /* Brand / Primary */\n  --twilight-sky: #00449d;\n  --twilight-hover: #007bdd;\n  --twilight-active: #072b5e;\n  --day-sky: #82b1e8; /* brand light tint — secondary chart series */\n  --pink-haze: #f7598c;\n\n  /* Ink / Text hierarchy */\n  --ink: #0a1f44;\n  --ink-soft: #3f526e;\n  --storm-gray: #333333;\n  --ink-mute: #8b97a8;\n\n  /* Surfaces */\n  --surface: #ffffff;\n  --canvas: #faf8f5; /* warm off-white page background — never pure white */\n  --sky-mist: #ebf2fa;\n  --sky-mist-border: #d4e4f5;\n  --table-header-bg: #f8f9fa;\n  --field-disabled: #f0f2f5;\n  --hairline: #e8e2d8;\n  --focus-ring: #82b1e8;\n\n  /* Semantic — status badges */\n  --success-bg: #e1f5ee;\n  --success-text: #0f6e56;\n  --warning-bg: #faeeda;\n  --warning-text: #854f0b;\n  --danger-bg: #fcebeb;\n  --danger-text: #a32d2d;\n  --info-bg: #ebf2fa;\n  --info-text: #0c447c;\n  --neutral-bg: #f0f2f5;\n  --neutral-text: #3f526e;\n\n  /* Semantic — actions & icons */\n  --danger: #e85642;\n  --danger-hover: #c73f2d;\n  --icon-warning: #ffb31a;\n  --icon-success: #1b605d;\n\n  /* Status intents (financial statements — tie-out, figures) */\n  --status-success: #1b605d; /* Midnight Green — tie-out ok, positive */\n  --midnight-green: #1b605d;\n  --amount-positive: #1b605d; /* positive financial figures (teal) */\n  --amount-negative: #e85642; /* negative financial figures (orange) */\n\n  /* Backdrop */\n  --backdrop: rgba(10, 31, 68, 0.35);\n\n  /* Layout — combined height of the global header + sticky project nav bar.\n     Workspace tabs subtract this from the viewport (`calc(100vh - var(--workspace-chrome-h))`)\n     so each tab owns its own scroll region instead of growing the document.\n     Single source of truth for the offset Reports/Dashboard/Policies share. */\n  --workspace-chrome-h: 107px;\n\n  /* Rail gradient (replaces the prototype's gradient-blue-rail.png — colors sampled\n     from that PNG: a subtle deep-navy fade, NOT a bright-blue ramp) */\n  --rail-gradient: linear-gradient(180deg, #003063 0%, #011e50 100%);\n  /* Rail foreground (inactive icon + label) — white at 62% over the gradient */\n  --rail-fg-muted: rgba(255, 255, 255, 0.62);\n  /* Count-badge border — matches the rail's upper gradient stop so the badge reads as inset */\n  --rail-badge-border: #003063;\n\n  /* Typography */\n  --font-sans: 'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  /* Serif for financial-statement / report headings so statements read like\n     printed documents. Lora is loaded via a <link> in src/index.html. */\n  --font-doc: 'Lora', Georgia, 'Times New Roman', serif;\n  --h1-size: 24px;\n  --h1-weight: 700;\n  --h1-tracking: -0.015em;\n  --h1-lh: 1.2;\n  --h2-size: 20px;\n  --h2-weight: 700;\n  --h2-tracking: -0.01em;\n  --h2-lh: 1.25;\n  --h3-size: 16px;\n  --h3-weight: 600;\n  --h3-tracking: -0.005em;\n  --h3-lh: 1.3;\n  --h4-size: 14px;\n  --h4-weight: 500;\n  --h4-tracking: 0;\n  --h4-lh: 1.35;\n  --body-size: 14px;\n  --body-weight: 400;\n  --body-lh: 1.6;\n  --sm-size: 12px;\n  --sm-weight: 400;\n  --sm-lh: 1.5;\n  --label-size: 11px;\n  --label-weight: 600;\n  --label-tracking: 0.08em;\n  --button-size: 14px;\n  --button-weight: 500;\n\n  /* Spacing (4pt grid) */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 24px;\n  --space-6: 32px;\n  --space-7: 48px;\n  --space-8: 64px;\n\n  /* Radius */\n  --radius-s: 4px;\n  --radius-m: 8px;\n  --radius-l: 12px;\n  --radius-xl: 20px;\n  --radius-full: 9999px;\n\n  /* Elevation */\n  --e0: none;\n  --e1: 0 1px 3px rgba(10, 31, 68, 0.06), 0 1px 2px rgba(10, 31, 68, 0.04);\n  --e2: 0 4px 12px rgba(10, 31, 68, 0.09), 0 2px 4px rgba(10, 31, 68, 0.05);\n  --e3: 0 8px 28px rgba(10, 31, 68, 0.13), 0 3px 8px rgba(10, 31, 68, 0.07);\n  --e4: 0 20px 48px rgba(10, 31, 68, 0.18), 0 6px 16px rgba(10, 31, 68, 0.1);\n}\n\n/* Semantic type classes */\n.app-h1 {\n  font-family: var(--font-sans);\n  font-size: var(--h1-size);\n  font-weight: var(--h1-weight);\n  letter-spacing: var(--h1-tracking);\n  line-height: var(--h1-lh);\n  color: var(--ink);\n  margin: 0;\n}\n.app-h2 {\n  font-family: var(--font-sans);\n  font-size: var(--h2-size);\n  font-weight: var(--h2-weight);\n  letter-spacing: var(--h2-tracking);\n  line-height: var(--h2-lh);\n  color: var(--ink-soft);\n  margin: 0;\n}\n.app-h3 {\n  font-family: var(--font-sans);\n  font-size: var(--h3-size);\n  font-weight: var(--h3-weight);\n  letter-spacing: var(--h3-tracking);\n  line-height: var(--h3-lh);\n  color: var(--ink-soft);\n  margin: 0;\n}\n.app-h4 {\n  font-family: var(--font-sans);\n  font-size: var(--h4-size);\n  font-weight: var(--h4-weight);\n  line-height: var(--h4-lh);\n  color: var(--ink-soft);\n  margin: 0;\n}\n.app-body {\n  font-family: var(--font-sans);\n  font-size: var(--body-size);\n  font-weight: var(--body-weight);\n  line-height: var(--body-lh);\n  color: var(--storm-gray);\n}\n.app-sm {\n  font-family: var(--font-sans);\n  font-size: var(--sm-size);\n  font-weight: var(--sm-weight);\n  line-height: var(--sm-lh);\n  color: var(--ink-mute);\n}\n.app-label {\n  font-family: var(--font-sans);\n  font-size: var(--label-size);\n  font-weight: var(--label-weight);\n  letter-spacing: var(--label-tracking);\n  text-transform: uppercase;\n  color: var(--ink-mute);\n}\n\n/* Reports viewer animations (TxnPanel overlay + slide-in, create-draft spinner) */\n@keyframes repFade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes repSlideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n@keyframes uiSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
